<div class="grid-x grid-margin-x">
  @if (!externalView) {
    <div class="cell small-12">
      <h4 class="bold">{{ orgName }}</h4>
    </div>
  }
  <div class="cell medium-6">
    <div class="grid-x">
      <div class="cell small-8">
        <h2 class="h5 no-margin">Amount Required:</h2>
        <p class="h2 bold no-margin" [innerHTML]="requiredBondingAmount"></p>
        <p class="small-font-size no-margin">Minimum - see i icon</p>
      </div>
      <div class="cell small-4">
        @if (bondingDecisionBasis) {
          <span class="no-margin no-padding display-inline-block"
            [popover]="{ text: bondingDecisionBasis, position: 'bottom' }">
            <svg-icon icon="icon-info" class="small dark-gray"></svg-icon>
          </span>
        }
      </div>
    </div>
  </div>
  <div class="cell medium-6">
    <h2 class="h5 no-margin red" [ngClass]="{ 'red': !isCompliant }">Amount Provided:</h2>
    <p class="h2 bold" [ngClass]="{ 'red': !isCompliant }" [innerHTML]="providedBondingAmount"></p>
  </div>
  <div class="cell medium-6">
    <div class="grid-x">
      <h2 class="h5 no-margin">Date of first confirmation that Financial Statement update was received by owner:</h2>
      <div class="cell small-3">
        <input type="text" class="dateInput" mask="M0/d0/0000" showMaskTyped="true" dropSpecialCharacters="false" id="firstReceiptConfirmationDate" [(ngModel)]=firstReceiptConfirmationDate
          [disabled]="!isInEditMode || hasFirstConfirmationDate" />
        </div>
        @if (firstReceiptConfirmationEntryDisplayName) {
          <div class="cell small-9">
            First receipt confirmed by: {{firstReceiptConfirmationEntryDisplayName}}
          </div>
        }
      </div>
    </div>
    <div class="cell medium-6">
      <div class="grid-x">
        <h2 class="h5 no-margin">Date of second confirmation that Financial Statement update was received by owner:</h2>
        <div class="cell small-3">
          <input type="text" class="dateInput" mask="M0/d0/0000" showMaskTyped="true" dropSpecialCharacters="false" id="secondReceiptConfirmationDate" [(ngModel)]=secondReceiptConfirmationDate
            [disabled]="!isInEditMode || !hasFirstConfirmationDate" />
          </div>
          @if (secondReceiptConfirmationEntryDisplayName) {
            <div class="cell small-9">
              First receipt confirmed by: {{secondReceiptConfirmationEntryDisplayName}}
            </div>
          }
        </div>

      </div>
      <div class="cell medium-6">
        <div class="grid-x">
          <h2 class="h5 no-margin">Last reviewed Date (Altering this will reset Confirmation Dates):</h2>
          <div class="cell small-3">
            <input type="text" class="dateInput" mask="M0/d0/0000" showMaskTyped="true" dropSpecialCharacters="false" id="lastReviewedDate" [(ngModel)]=lastReviewedDate [disabled]="!isInEditMode" />
          </div>
          @if (lastReviewedDateEntryDisplayName) {
            <div class="cell small-9">
              Last reviewed by: {{lastReviewedDateEntryDisplayName}}
            </div>
          }
        </div>
      </div>
      <div class="cell medium-6">
        <h2 class="h5 no-margin">Expiration Date (Calculated):</h2>
        <input type="text" class="dateInput" mask="M0/d0/0000" showMaskTyped="true" dropSpecialCharacters="false" id="expirationDate" [(ngModel)]=expirationDate [disabled]="true" />
      </div>
      <div class="cell small-12">
        <div class="grid-x">
          <div class="cell small-6">
            <button class="button" min-width="500px" (click)="editModeToggle()" [disabled]="!editEnabled"> {{ editButtonText }}</button>
          </div>
          @if (isInEditMode) {
            <div class="cell small-6">
              <button class="button" min-width="500px" (click)="save()"> Save Changes</button>
            </div>
          }
        </div>
      </div>
      <div class="cell small-12 minor-margin-top"><p class="small-font-size italic no-margin-bottom">The amount of financial assurance listed does not include any additional financial assurance that may additionally be required as a result of a court order, chief’s order, compliance agreement, or a temporary inactive status authorization</p></div>
    </div>
    <confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
